// extracted by mini-css-extract-plugin
export default {"container":"Animation_container__kmACB","animation":"Animation_animation__Gh+Pt","box":"Animation_box__diSO+","content":"Animation_content__LLiNF"};